<!-- <h1 color="info" style="position: fixed;z-index: 998;">  -->
     <!-- <img class="bmlogo" src="../../assets/bm-small.webp" alt="BharatMandi" style="height:3rem;margin:0 16px 0 50px" /> -->
     <app-spinner-overlay [showSpinner]="showSpinner"></app-spinner-overlay>
     <app-spinner-overlay [showSpinner]="showSpinnerWithMessage" [subText]="subText"></app-spinner-overlay>
     <div class="loading-overlay" *ngIf="loading">
       <div class="spinner"></div>
     </div>
     
    <img class="bmlogo" src="{{logo}}" alt="BharatMandi" style="height:3rem;margin:0 16px 0 50px" />
<!--   
   <h1 style="font-weight: bold;padding-top: 1rem;width: auto;" >WhatsLoan Marketplace</h1>  -->
    <div class="empty-space"></div>
    <p style="font-size:small;margin:0 !important">Powered by</p>
    <!-- <img class="logo" src="../../assets/whatsloan.png" alt="WhatsLoan" style="margin-left: 16px;
    width      : auto; height:32px;margin:0 16px 0 0 ;background:none;"  /> -->
     <!-- <img class="logo" src="../../assets/whatsloan.png" alt="WhatsLoan" style="height:3rem;margin:0 16px 0 0" />  -->
<!-- </h1> -->
    
<br>
<br>
<mat-progress-bar *ngIf="progressBar"  mode="buffer"></mat-progress-bar>
<div style="text-align: center;">
  <h2 *ngIf="verified">Thank You</h2>
  <h3 *ngIf="verified">Your {{data}} has been verified.</h3>
  <h2 *ngIf="linkExpired">Sorry...! Link has expired.</h2>
</div>
<br>
<br>

